/* global fetch, */
import get from 'lodash/get';
import { PAYPAL_API_URLS } from './paypal-constants';
import { setSessionUrls, clearLocalStorage } from './paypal-utils';
import request from './request';

const createOrder = (data, actions) => {
	//Clear Previous PayPal State If Set
	clearLocalStorage();

	return request(PAYPAL_API_URLS.create, 'POST')
		.then((response) => {
			if (get(response, 'sessionUrls')) {
				setSessionUrls(get(response, 'sessionUrls'));
			}

			return get(response, 'token');
		});
};

module.exports = createOrder;
